import * as React from 'react';
import { EContainerTypes } from '../types';

export interface IDealSaleOfferLabelContext {
  onStepYes?(): void;
  onStepNo?(): void;
  onPreviousStep(): void;
  onClose(): void;
  previousStep: EContainerTypes;
}

export const FormContext = React.createContext<IDealSaleOfferLabelContext>({
  onPreviousStep: Function.prototype as IDealSaleOfferLabelContext['onPreviousStep'],
  onClose: Function.prototype as IDealSaleOfferLabelContext['onClose'],
  previousStep: EContainerTypes.NullContainer,
});
